import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '@/views/index/index'
import multimediaIndex from '@/views/multimedia/index'
import topicList from '@/views/multimedia/topicList'
import topicDetails from '@/views/multimedia/topicDetails'
import video from '@/views/multimedia/video'
import pictorialMatter from '@/views/pictorialMatter/index'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: Index,
    meta: {
      title: '现代农业技术平台'
    }
  },
  {
    path: '/multimedia',
    name: 'multimedia',
    component: multimediaIndex,
    meta: {
      title: '现代农业技术平台'
    }
  },
  {
    path: '/topic',
    name: 'topic',
    component: topicList,
    meta: {
      title: '现代农业技术平台'
    }
  },
  {
    path: '/topicDetails',
    name: 'topicDetails',
    component: topicDetails,
    meta: {
      title: '现代农业技术平台'
    }
  },
  {
    path: '/pictorialMatter',
    name: 'pictorialMatter',
    component: pictorialMatter,
    meta: {
      title: '现代农业技术平台'
    }
  },
  {
    path: '/topicDetails/video',
    name: 'video',
    component: video,
    meta: {
      title: '现代农业技术平台'
    }
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // 路由跳转后，让页面回到顶部
  document.body.scrollTop = 0
  document.documentElement.scrollTop = 0
  window.pageYOffset = 0
  // 调用 next()，一定要调用 next 方法，否则钩子就不会被销毁!!
  next()
})

export default router
